export const GET_DIRECTORS = 'GET_DIRECTORS';
export const getDirectors = () => ({
    type: GET_DIRECTORS
});

export const DIRECTORS_FETCH_REQUESTED = 'DIRECTORS_FETCH_REQUESTED';
export const fetchDirectors = () => ({
    type: DIRECTORS_FETCH_REQUESTED
});

export const DIRECTORS_FETCH_SUCCEED = 'DIRECTORS_FETCH_SUCCEED';
export const directorsFetchSucceed = (directors) => ({
    type: DIRECTORS_FETCH_SUCCEED,
    directors
});

export const DIRECTORS_FETCH_FAILED = 'DIRECTORS_FETCH_FAILED';
export const directorsFetchFailed = () => ({ type: DIRECTORS_FETCH_FAILED });

export const RESET_DIRECTORS = 'DIRECTORS_FETCH_RESET';
export const resetDirectors = () => ({
    type: RESET_DIRECTORS
});
